import React from 'react';
import '../style/about.css';
import { Container, Row, Col } from 'react-bootstrap';
import thankyou from '../assets/thankyou.png';

const Return = () => {
  return (
    <div>
    <section className="thankyoubanner" >
     <Container>
        <Row>
            <Col md={12}>
               {/* <img src={thankyou} /> */}
               Thank you for registering as a vendor on Local Roots<br />
               <a href='/'>Back To Home</a>
            </Col>
        </Row>
     </Container>
    </section>
    </div>
  );
};


export default Return;
